import type { Product } from 'reactApp/types/Billing';
import { getPrice } from 'reactApp/ui/TariffSectionNew/helpers/getPrice';
import { isMonthPeriod, isTransactPeriod } from 'reactApp/utils/Period';
import { formatPrice } from 'reactApp/utils/priceHelpers';

interface useProductPriceProps {
    product: Product;
    providedButtonText?: string;
}

export const useProductPrice = ({ product, providedButtonText }: useProductPriceProps) => {
    const [_, discount, __, productMonthPriceAsText] = getPrice({
        product,
        periodDivider: 'в',
    });

    // tempexp_cloudweb-20095-next_line
    const transactText = isTransactPeriod(product.period) ? `Разовый платёж ${product.price} ₽` : '';

    const trialPrice = isMonthPeriod(product.period) ? 'Попробовать за 1 ₽' : '1 ₽ в первый месяц';
    const priceText = providedButtonText || (product.hasTrial ? trialPrice : productMonthPriceAsText);

    const finalPriceText = priceText.replace('${price}', `${formatPrice(product.price)} ₽`);

    return { discount, priceText: finalPriceText, transactText };
};
